import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

export default class MultiCheckbox extends React.Component {
    constructor(props) {
        super(props);
    }
    onChange(event) {
        if (this.props.onChange) {
            if(this.props.multiple) {
                let value = [];
                $(ReactDOM.findDOMNode(this)).find('input:checked').each((index, element) => { value.push(element.value); });
                this.props.onChange(value);
            } else {
                this.props.onChange($(event.target).val());
            }
        }
    }
    componentDidMount()
    {
        if (!this.props.expanded && Object.keys(this.props.choices).length == 1 && typeof this.props.placeholder === 'undefined' && this.props.onChange) {
            if (this.props.multiple && this.props.value.indexOf(Object.keys(this.props.choices)[0]) < 0) {
                this.props.onChange(Object.keys(this.props.choices));
            } else if (this.props.value !== Object.keys(this.props.choices)[0]) {
                this.props.onChange(Object.keys(this.props.choices)[0]);
            }
        }
    }
    componentDidUpdate(oldProps, oldState)
    {
        let root = $(ReactDOM.findDOMNode(this));
        let attribute = this.props.expanded?'checked':'selected';

        // Unset all selected states
        root.find('option, input').each((index, node) => { node[attribute] = false; });

        if (!this.props.multiple) {
            if (!this.props.expanded || typeof this.props.value !== 'undefined' ) {
                var nodes = root.find('[value="' + (typeof this.props.value !== 'undefined' ? this.props.value : '') + '"]');
                if (nodes.length > 0) {
                    nodes[0][attribute] = true;
                }
            }
        } else if (typeof this.props.value !== 'undefined' && null !== this.props.value) {
            this.props.value.forEach((value) => {
                var nodes = root.find('[value="' + value + '"]');
                if (nodes.length > 0) {
                    nodes[0][attribute] = true;
                }
            });
        }
    }
    render() {
         return <div>{Object.keys(this.props.choices).map(value => {
            let checked = this.props.value == value;
            if (this.props.multiple && typeof this.props.value !== 'undefined' && null !== this.props.value) {
                checked = this.props.value.indexOf(value) >= 0;
            }
            return (
                <label key={value} className={this.props.multiple?'checkbox':'radio'}>
                    <span className={'input'+(checked?' checked':'')}>
                        <input
                            type={this.props.multiple?'checkbox':'radio'}
                            name={this.props.name}
                            defaultChecked={checked}
                            value={value}
                            disabled={this.props.disabled || (
                                typeof this.props.availableChoices !== 'undefined'
                                 && null !== this.props.availableChoices
                                 && typeof this.props.availableChoices[value] === 'undefined'
                             )  ?  true : false}
                            readOnly={this.props.readonly}
                            onChange={this.onChange.bind(this)}
                        />
                    </span> {this.props.choices[value]}
                </label>
            )
        })}</div>;
    }
}



// WEBPACK FOOTER //
// ./src-js/Fratello/Atoms/MultiCheckbox.jsx